module.exports = __webpack_public_path__ + "assets/asset_fire.e1b94543.svg";